import React from 'react';
import PropTypes from "prop-types";
import Card from "../../Common/Card";
import intl from "react-intl-universal";
import common from '../../../../common/common';
import styles from './index.module.scss';

class CardItem extends React.Component {
    constructor(props) {
        super(props);
    }

    static defaultProps = {
        cover: '',
        title: '',
        showValidTerm: false,
        validTerm: 0,
        stock: 0,
        unlimitedStock: false,
        starValue: 0,
        showLabel: false,
        hoverable: true,
        hoverContent: null
    };

    static propTypes = {
        cover: PropTypes.string, // 封面图
        title: PropTypes.string, // 标题
        showValidTerm: PropTypes.bool, // 是否展示使用权天数
        validTerm: PropTypes.number, // 使用权天数
        stock: PropTypes.number, // 库存
        unlimitedStock: PropTypes.bool, // 库存是否无限
        starValue: PropTypes.number, // 价值多少颗星星
        showLabel: PropTypes.bool, // 是否展示已拥有角标
        hoverable: PropTypes.bool, // 是否可以hover
        // hover弹层内容
        hoverContent: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.node
        ])
    };

    componentDidMount() {
    }


    render() {
        const {
            cover,
            title,
            showValidTerm,
            validTerm,
            stock,
            unlimitedStock,
            starValue,
            showLabel,
            hoverable,
            hoverContent
        } = this.props;

        const meta = (
            <React.Fragment>
                <p className="title" title={title}>{title}</p>
                {
                    showValidTerm && validTerm && <div className="description">{common.isPermanent(validTerm) ? intl.get('PERPETUITY_RIGHT') : intl.get('USE_DAYS', {day: validTerm})}</div>
                }
            </React.Fragment>
        );

        const footer = (
            <div className="card-footer">
                <div className={`stock ${!stock ? 'sold-out' : ''}`}>{stock ? `${unlimitedStock || stock > 999 ? intl.get('STOCK_FULLY') : intl.get('STOCK', {stock})}` : intl.get('SOLD_OUT')}</div>
                <div className="star-value">
                    <label className="value">{starValue}</label>
                    <span className="icon-star"/>
                </div>
            </div>
        );

        return (
            <Card
                className="category-card"
                cover={cover}
                meta={meta}
                footer={footer}
                label={
                    showLabel ? {
                        visible: true,
                        style: {
                            background: '#FCC868',
                            color: '#AB5842'
                        },
                        text: intl.get('OWNED')
                    } : {
                        visible: false
                    }
                }
                hoverable={hoverable}
                hoverContent={hoverContent}
            />
        )
    }
}
export default CardItem;